/*
  The Christmas order-by line (snippets/ascot-xmas-line.liquid, owner message 7, 2026-10-09). The server prints the state for
  the day the page was rendered; a cached page can be older than today, so this picks again by the calendar date in
  America/Chicago (read by zone NAME, so daylight saving cannot move the day) and hides the line outside every state.
  Each element carries its states as [from, to, text] in data-ascot-xmas; from "" means open at the start. FAQ states carry
  a <br> between their rows, written by the theme, never by a visitor. Runs once per page however many snippets load it,
  and again when the cart drawer or a section re-renders (a MutationObserver on new [data-ascot-xmas] nodes).
*/
(function () {
  if (window.__ascotXmas) return;
  window.__ascotXmas = true;

  function todayCentral() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
      return get('year') + '-' + get('month') + '-' + get('day');
    } catch (e) {
      return null;
    }
  }

  // the PDP line has a second set of states for an order without engraving (data-ascot-xmas-plain); it is used while the trust
  // row's "Ships in" line beside it shows its plain copy, which the personalization flows switch on the Engraving value
  // message 18 item 3: the PDP line sits inside the "Christmas delivery dates" row, so the "Ships in" line is looked up in the
  // section around it
  function productionTimeFor(el) {
    var scope = (el.closest && el.closest('.shopify-section')) || el.parentElement;
    return scope ? scope.querySelector('[data-production-time]') : null;
  }
  function plainNow(el) {
    var pt = productionTimeFor(el);
    return !!pt && pt.hasAttribute('data-production-time-plain') && pt.textContent.trim() === pt.getAttribute('data-production-time-plain').trim();
  }
  function apply(el) {
    var states;
    var attr = el.hasAttribute('data-ascot-xmas-plain') && plainNow(el) ? 'data-ascot-xmas-plain' : 'data-ascot-xmas';
    try { states = JSON.parse(el.getAttribute(attr) || '[]'); } catch (e) { return; }
    var today = todayCentral();
    if (!today) return;
    var text = '';
    for (var i = 0; i < states.length; i++) {
      var s = states[i];
      if ((s[0] === '' || s[0] <= today) && s[1] >= today) { text = s[2]; break; }
    }
    if (el.getAttribute('data-ascot-xmas-shown') === text && el.hidden === !text) return;
    el.setAttribute('data-ascot-xmas-shown', text);
    el.innerHTML = text;
    el.hidden = !text;
  }

  function watchPlain(el) {
    if (el.__ascotXmasWatch || !el.hasAttribute('data-ascot-xmas-plain')) return;
    var pt = productionTimeFor(el); if (!pt) return;
    el.__ascotXmasWatch = true;
    new MutationObserver(function () { apply(el); }).observe(pt, { childList: true, characterData: true, subtree: true });
  }
  // the cart drawer's "Christmas delivery dates" row (snippets/rush-production.liquid, long run 2 item c) carries the last day it
  // shows as data-ascot-xmas-until; after that day in Central Time it hides, whatever day the page was rendered
  function applyUntil(el) {
    var today = todayCentral(); if (!today) return;
    var gone = today > el.getAttribute('data-ascot-xmas-until');
    if (el.hidden !== gone) el.hidden = gone;
  }
  function scan(root) {
    var list = (root || document).querySelectorAll('[data-ascot-xmas]');
    for (var i = 0; i < list.length; i++) { apply(list[i]); watchPlain(list[i]); }
    var until = (root || document).querySelectorAll('[data-ascot-xmas-until]');
    for (var k = 0; k < until.length; k++) applyUntil(until[k]);
  }

  function start() {
    scan(document);
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.hasAttribute('data-ascot-xmas')) apply(n);
            else if (n.hasAttribute('data-ascot-xmas-until')) applyUntil(n);
            else if (n.querySelector('[data-ascot-xmas], [data-ascot-xmas-until]')) scan(n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
